import { useState, useEffect, useContext } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import {
  getAllSuperScreenLayouts,
  deleteSuperScreenLayout,
} from "../Games/networkCalls/networkCalls";
import { IconButton, Tooltip } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { AppContext } from "../../contexts/App.Context";
import { COLORS } from "../../utils/colors";
import ConfirmationDialog from "../../components/UI/ConfirmationDialog";
import { CDN_URLS } from "../../constants";
const SavedLayouts = ({
  eventId,
  onLayoutChange,
  selected,
  isReadOnly,
  isControllable = false,
}) => {
  const [savedLayouts, setSavedLayouts] = useState([
    { name: "Blank", _id: 0, backgroundImage: CDN_URLS.SHADOW_BACKGROUND },
  ]);
  const [selectedLayoutId, setSelectedLayoutId] = useState(selected);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const appContext = useContext(AppContext);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  const getData = async () => {
    const layouts = await getAllSuperScreenLayouts(eventId);
    let data = isControllable
      ? layouts.filter((layout) => layout?.isControllableOutput)
      : layouts || [];

    setSavedLayouts([
      { name: "Blank", _id: 0, backgroundImage: CDN_URLS.SHADOW_BACKGROUND },
      ...data,
    ]);
    if (isReadOnly && data.length) {
      setSelectedLayoutId(data[0]._id);
    } else {
      setSelectedLayoutId(selected || 0);
    }
  };
  const deleteLayout = async () => {
    await deleteSuperScreenLayout(selectedLayoutId);
    setShowConfirmationDialog(false);

    appContext.triggerToast(true, {
      type: "success",
      message: "Layout deleted successfully.",
    });
    getData();
  };
  useEffect(() => {
    getData();
  }, [eventId, selected]);
  useEffect(() => {
    const layout = savedLayouts.find(
      (layout) => layout._id === selectedLayoutId
    );

    onLayoutChange(layout);
    setSelectedLayout(layout);
  }, [selectedLayoutId]);

  const onChange = (e) => {
    setSelectedLayoutId(e.target.value);
  };

  return (
    <>
      <FormControl
        variant="standard"
        fullWidth
        sx={{ width: "100%", margin: "20px 0px" }}
      >
        <InputLabel sx={isReadOnly ? { color: "white" } : null}>
          Select from Saved Layouts
        </InputLabel>
        <Select
          variant="standard"
          value={selectedLayoutId}
          onChange={onChange}
          sx={{ color: COLORS.gray, background: "white", padding: "10px" }}
        >
          {savedLayouts.map(({ _id, name }) => (
            <MenuItem
              value={_id}
              key={_id}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
              }}
            >
              {name}
              {!isReadOnly && _id ? (
                <IconButton
                  sx={{ marginLeft: 10 }}
                  onClick={() => {
                    setShowConfirmationDialog(true);
                  }}
                >
                  <Tooltip title={"Delete"}>
                    <Delete />
                  </Tooltip>
                </IconButton>
              ) : null}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <ConfirmationDialog
        title="Delete Confirmation"
        confirmButtonText="Delete"
        message={`Are you sure you want to delete "${
          selectedLayout && selectedLayout.name ? selectedLayout.name : ""
        }"?`}
        show={showConfirmationDialog}
        onConfirm={deleteLayout}
        onClose={() => {
          setShowConfirmationDialog(false);
        }}
      />
    </>
  );
};
export default SavedLayouts;
